export default __webpack_public_path__ + "static/media/Snd_7_Starts.e84cadd5.mp3";